import SupplierBill from '../page/settle/supplier/SupplierBill';
import SupplierBillAdd from '../page/settle/supplier/SupplierBillAdd';
import SettlementSupplier from '../page/settle/supplier/SupplierSettlement'
import SettlementBillAdd from '../page/settle/supplier/SupplierSettlementAdd';
import BillJoint from '../page/settle/supplier/JointBill';
import BillJointAdd from '../page/settle/supplier/JointBillAdd';
import SettlementJoint from '../page/settle/supplier/JointSettlement';
import SettlementJointAdd from '../page/settle/supplier/JointSettlementAdd';
import Customer from "../page/settle/Customer.vue"
import Stores from "../page/settle/Stores.vue"
import Setting from "../page/settle/Setting.vue"
import detail from '@/components/template/detail'
import SupplierBillDetail from "../page/settle/supplier/SupplierBillDetail"
import SettlementBillDetail from "../page/settle/supplier/SupplierSettlementDetail"
import BillJointDetail from "../page/settle/supplier/JointBillDetail"
import SettlementJointDetail from "../page/settle/supplier/JointSettlementDetail"
import BillCustomer from "../page/settle/customer/BillCustomer"
import BillCustomerAdd from "../page/settle/customer/BillCustomerAdd"
import BillCustomerDetail from "../page/settle/customer/BillCustomerDetail"
import SettlementCustomer from "../page/settle/customer/SettlementCustomer"
import SettlementCustomerAdd from "../page/settle/customer/SettlementCustomerAdd"
import SettlementCustomerDetail from "../page/settle/customer/SettlementCustomerDetail"
import BillFranchise from "../page/settle/franchise/BillFranchise"
import BillFranchiseAdd from "../page/settle/franchise/BillFranchiseAdd"
import BillFranchiseDetail from "../page/settle/franchise/BillFranchiseDetail"
import SettlementFranchise from "../page/settle/franchise/SettlementFranchise"
import SettlementFranchiseAdd from "../page/settle/franchise/SettlementFranchiseAdd"
import SettlementFranchiseDetail from "../page/settle/franchise/SettlementFranchiseDetail"
import SupplierSettlement from "../page/settle/query/SupplierSettlement"
import CustomerSettlement from "../page/settle/query/CustomerSettlement"


export const settle = [{
  path: '/bill/supplier',
  name: 'SupplierBill',
  component: SupplierBill,
  meta: {
    requireAuth: true,
    title: '供应商对账单'
  }
},
  {
    path: '/bill/supplier/add',
    name: 'SupplierBillAdd',
    component: SupplierBillAdd,
    meta: {
      requireAuth: true,
      title: '供应商对账单'
    }
  },
  {
    path: '/bill/supplier/detail',
    name: 'SupplierBillDetail',
    component: SupplierBillDetail,
    meta: {
      requireAuth: true,
      title: '供应商对账单详情'
    },
  },
  {
    path: '/settlement/supplier',
    name: 'SettlementSupplier',
    component: SettlementSupplier,
    meta: {
      requireAuth: true,
      title: '供应商结算单'
    }
  },
  {
    path: '/settlement/supplier/add',
    name: 'SettlementBillAdd',
    component: SettlementBillAdd,
    meta: {
      requireAuth: true,
      title: '供应商结算单'
    }
  },
  {
    path: '/settlement/supplier/detail',
    name: 'SettlementBillDetail',
    component: SettlementBillDetail,
    meta: {
      requireAuth: true,
      title: '供应商结算单详情'
    },
  },
  {
    path: '/bill/joint',
    name: 'BillJoint',
    component: BillJoint,
    meta: {
      requireAuth: true,
      title: '联营对账单'
    }
  },
  {
    path: '/bill/joint/add',
    name: 'BillJointAdd',
    component: BillJointAdd,
    meta: {
      requireAuth: true,
      title: '联营对账单'
    }
  },
  {
    path: '/bill/joint/detail',
    name: 'BillJointDetail',
    component: BillJointDetail,
    meta: {
      requireAuth: true,
      title: '联营对账单详情'
    },
  },
  {
    path: '/settlement/joint',
    name: 'SettlementJoint',
    component: SettlementJoint,
    meta: {
      requireAuth: true,
      title: '联营结算单'
    }
  },
  {
    path: '/settlement/joint/add',
    name: 'SettlementJointAdd',
    component: SettlementJointAdd,
    meta: {
      requireAuth: true,
      title: '联营结算单'
    }
  },
  {
    path: '/settlement/joint/detail',
    name: 'SettlementJointDetail',
    component: SettlementJointDetail,
    meta: {
      requireAuth: true,
      title: '联营结算单详情'
    },
  },
  {
    path: '/settlement/customer',
    name: 'SettlementCustomer',
    component: SettlementCustomer,
    meta: {
      requireAuth: true,
      title: '客户结算单'
    },
  },
  {
    path: '/settlement/customer/add',
    name: 'SettlementCustomerAdd',
    component: SettlementCustomerAdd,
    meta: {
      requireAuth: true,
      title: '客户结算单'
    },
  },
  {
    path: '/settlement/customer/detail',
    name: 'SettlementCustomerDetail',
    component: SettlementCustomerDetail,
    meta: {
      requireAuth: true,
      title: '客户结算单详情'
    },
  },
  {
    path: '/settlement/stores',
    name: 'Stores',
    component: Stores,
    meta: {
      requireAuth: true,
      title: '门店结算'
    }
  },
  {
    path: '/settlement/setting',
    name: 'Setting',
    component: Setting,
    meta: {
      requireAuth: true,
      title: '结算设置'
    }
  },
  {
    path: '/bill/customer',
    name: 'BillCustomer',
    component: BillCustomer,
    meta: {
      requireAuth: true,
      title: '客户对账单'
    }
  },
  {
    path: '/bill/customer/add',
    name: 'BillCustomerAdd',
    component: BillCustomerAdd,
    meta: {
      requireAuth: true,
      title: '客户对账单'
    }
  },
  {
    path: '/bill/customer/detail',
    name: 'BillCustomerDetail',
    component: BillCustomerDetail,
    meta: {
      requireAuth: true,
      title: '客户对账单详情'
    },
  },

  {
    path: '/bill/franchise',
    name: 'BillFranchise',
    component: BillFranchise,
    meta: {
      requireAuth: true,
      title: '加盟店对账单'
    }
  },
  {
    path: '/bill/franchise/add',
    name: 'BillFranchiseAdd',
    component: BillFranchiseAdd,
    meta: {
      requireAuth: true,
      title: '加盟店对账单'
    }
  },
  {
    path: '/bill/franchise/detail',
    name: 'BillFranchiseDetail',
    component: BillFranchiseDetail,
    meta: {
      requireAuth: true,
      title: '加盟店对账单详情'
    },
  },
  {
    path: '/settlement/franchise',
    name: 'SettlementFranchise',
    component: SettlementFranchise,
    meta: {
      requireAuth: true,
      title: '加盟店结算单'
    },
  },
  {
    path: '/settlement/franchise/add',
    name: 'SettlementFranchiseAdd',
    component: SettlementFranchiseAdd,
    meta: {
      requireAuth: true,
      title: '加盟店结算单'
    },
  },
  {
    path: '/settlement/franchise/detail',
    name: 'SettlementFranchiseDetail',
    component: SettlementFranchiseDetail,
    meta: {
      requireAuth: true,
      title: '加盟店结算单详情'
    },
  },
  {
    path: '/query/supplier/settlement',
    name: 'SupplierSettlement',
    component: SupplierSettlement,
    meta: {
      requireAuth: true,
      title: '供应商结算查询'
    },
  },
  {
    path: '/query/customer/settlement',
    name: 'CustomerSettlement',
    component: CustomerSettlement,
    meta: {
      requireAuth: true,
      title: '客户结算查询'
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/settle.route.js